import { render, staticRenderFns } from "./ViewSeedingTaskDetail.vue?vue&type=template&id=f9c1b31c&scoped=true"
import script from "./ViewSeedingTaskDetail.vue?vue&type=script&lang=js"
export * from "./ViewSeedingTaskDetail.vue?vue&type=script&lang=js"
import style0 from "./ViewSeedingTaskDetail.vue?vue&type=style&index=0&id=f9c1b31c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c1b31c",
  null
  
)

export default component.exports